import { HebDateUtil } from '../Util/HebDateUtil';
import { HDate, months } from '@hebcal/core';
import { DataBroker } from './DataBroker';


const SHIUR_INDEX = [
	[  1,   9], 		[ 10,  17],			[ 18,  22],			[ 23,  28],			[ 29,  34],
	[ 35,  38], 		[ 39,  43],			[ 44,  48],			[ 49,  54],			[ 55,  59],
	[ 60,  65], 		[ 66,  68],			[ 69,  71],			[ 72,  76],			[ 77,  78],
	[ 79,  82], 		[ 83,  87],			[ 88,  89],			[ 90,  96],			[ 97, 103],
	[104, 105], 		[106, 107],			[108, 112],			[113, 118],			[119, 119],
	[119, 119], 		[120, 134],			[135, 139],			[140, 144],			[145, 150]
];




function GetShiurIndex(hDate) {
	const Shiurim = SHIUR_INDEX[hDate.dd-1];

	let output = [];


	if (HebDateUtil.IsNoTachanun(hDate))
		output.push(20);

	if (hDate.dd === 25)
		output.push(119.1);
	else if (hDate.dd === 26)
		output.push(119.2);
	else
		for (let i=Shiurim[0]; i<=Shiurim[1]; i++)
			output.push(i);


	// יום ל לחודש שיש בו רק כט יום
	if (hDate.dd === 29 && hDate.daysInMonth(hDate.mm, hDate.yy) === 29)
		for (let i=SHIUR_INDEX[29][0]; i<=SHIUR_INDEX[29][1]; i++)
			output.push(i);


	// תוספת 3 פרקים
	if (hDate.mm === months.ELUL || (hDate.mm === months.TISHREI && hDate.dd < 10)) {
		output.push(0);

		let end_perek = hDate.dd * 3;
		if (hDate.mm === months.TISHREI)
			end_perek += (29*3);
		
		let start_perek = end_perek - 2;

		for (let i=start_perek; i<=end_perek; i++)
			output.push(i);
	}
	else if (hDate.mm === months.TISHREI && hDate.dd === 10) {
	}

	return output;
};
function GetBirthdaysIndex(hDate) {
	let output = [];
	
	const settings = JSON.parse(localStorage.getItem('tfilulari/settings'));

	for (let i=0; i<settings.thBirthday.length; i++) {
		const hBirthday = new HDate(
							settings.thBirthday[i].d,
							settings.thBirthday[i].m,
							settings.thBirthday[i].y
						);

		let yyDiff = hDate.yy - hBirthday.yy;
		const mmddDATE = HebDateUtil.GetMonthOrder(hDate.mm)*100 + hDate.dd;
		const mmddBRTH = HebDateUtil.GetMonthOrder(hBirthday.mm)*100 + hBirthday.dd;


		if (mmddDATE < mmddBRTH) {
			output.push({perekIndex:yyDiff, name:settings.thBirthday[i].name});
		}
		else if (mmddDATE > mmddBRTH) {
			output.push({perekIndex:(++yyDiff), name:settings.thBirthday[i].name});
		}
		else if (mmddDATE === mmddBRTH) {
			output.push({perekIndex:yyDiff, name:settings.thBirthday[i].name});
			output.push({perekIndex:(++yyDiff), name:settings.thBirthday[i].name});
		}
	}

	return output;
}



function RenderShiur(dataShiur, dataBirthday, hDate) {
	return	<div className='Tehilim'>
				<center className='shiur-title'><b>תהלים ליום { HebDateUtil.GetHebrewDateShort(hDate) }</b></center>
				<div dangerouslySetInnerHTML={{ __html: dataShiur }} />

				{ dataBirthday.map(i => i) }
			</div>;
};


export async function GetTH(gregDate) {
	const hDate = new HDate(gregDate);
	let arrIndex = GetShiurIndex(hDate);
	let dataShiur = "";
	let dataBirthday = [];
	let loaded = true;

	for (let i=0; i<arrIndex.length; i++) {
		let tmp = await DataBroker.getDataText('th/' + arrIndex[i]);
		dataShiur += tmp;

		if (tmp === null)
			loaded = false;
	}
	
	arrIndex = GetBirthdaysIndex(hDate);
	if (arrIndex)

	for (let i=0; i<arrIndex.length; i++) {
		let tmp = await DataBroker.getDataText('th/' + arrIndex[i].perekIndex);
		dataBirthday.push(	<>
								<center className='shiur-title'><b>הפרק של {arrIndex[i].name}</b></center>
								<div dangerouslySetInnerHTML={{ __html: tmp }} />
							</>);
//		dataBirthday += tmp;

		if (tmp === null)
			loaded = false;
	}


	return new Promise((myResolve, myReject) => {
		if (!loaded)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(dataShiur, dataBirthday, hDate));
	});
};